export const ONE_MB = 1024 * 1024;
export const ONE_GB = ONE_MB * 1024;
export const DEFAULT_PAGE_TITLE = 'Sync.com';
export const DEFAULT_CONTROL_DEBOUNCE_TIME_MS = 300;
export const DEFAULT_SCROLL_THROTTLE_TIME_MS = 500;

export const DOWNLOAD_CHUNK_TIMEOUT_MS = 600000; // 10min

export const NOTIFICATION_BACKOFF_INITIAL_MS = 1000; // 1s
export const NOTIFICATION_BACKOFF_MAX_MS = 30000; // 30s
export const NOTIFICATION_JOB_POLLING_INTERVAL_MS = 2000; // 2s
export const NOTIFICATIONS_DEBOUNCE_TIME_MS = 500;

export const BUTTONS_CONFIG = {
  DEFAULT_WIDTH: '236px',
  DEFAULT_WIDTH_SM: '177px',
};

export const HELP_LINKS = {
  KNOWLEDGE_BASE: 'https://help.sync.com/hc/en-us',
  HElP_CENTER: 'https://help.sync.com/hc/en-us ',
  WEB_PANEL_OVERVIEW: 'https://help.sync.com/hc/en-us/articles/38275630257555-How-to-use-the-Sync-com-web-panel',
  SHARING_FOLDERS: 'https://help.sync.com/hc/en-us/articles/38275626644243-Sharing-files-and-folders-with-links',
  ACCOUNT_BILLING_FAQ: 'https://help.sync.com/hc/en-us/sections/37938359533331-Account-Billing',
  CHANGE_PLAN: 'https://help.sync.com/hc/en-us/articles/47074638027155-How-do-I-change-my-Sync-plan',
  PRO_TEAM_STANDARD_ADMIN:
    'https://help.sync.com/hc/en-us/articles/38275612232595-Getting-Started-With-Pro-Teams-Standard-Administrator-Guide',
  PRO_TEAM_UNLIMITED_ADMIN:
    'https://help.sync.com/hc/en-us/articles/38275626032275-Getting-Started-With-Pro-Teams-Unlimited-Administrator-Guide',
  BRANDING_LEARN_MORE:
    'https://help.sync.com/hc/en-us/articles/38275666838675-Customizing-Sync-branding-with-your-own-logo',
  ADD_USERS_SHARED_FOLDER:
    'https://help.sync.com/hc/en-us/articles/38275627100563-How-to-use-team-shared-folders#manageshare',
  HOW_TO_USE_SHARED_FOLDER: 'https://help.sync.com/hc/en-us/articles/38275627100563-How-to-use-team-shared-folders',
  TEXT_EDITOR_SHARED_OVERWRITE: 'https://www.sync.com/help/texteditor',
  DOWNLOAD_CSV_TEMPLATE_UNLIMITED:
    'https://help.sync.com/hc/en-us/articles/38275626032275-Getting-Started-With-Pro-Teams-Unlimited-Administrator-Guide#teamusers',
  DOWNLOAD_CSV_TEMPLATE_STANDARD:
    'https://help.sync.com/hc/en-us/articles/38275612232595-Getting-Started-With-Pro-Teams-Standard-Administrator-Guide#teamusers',
  VAULT_LEARN_MORE: 'https://help.sync.com/hc/en-us/articles/38275630195347-What-is-the-Sync-Vault',
  CONTACT_SUPPORT: 'https://help.sync.com/hc/en-us/requests/new?fromcp=1',
  CUSTOMER_SERVICE: 'https://help.sync.com/hc/en-us/requests/new?ticket_form_id=39041883966483',
  CLOUDFLARE_HELP_URL: 'https://www.sync.com/help/cloudflareapi?errorcode',
  CLOUDFLARE_BLOCKED_TROUBLESHOOTING:
    'https://help.sync.com/hc/en-us/articles/52922572016403-Troubleshooting-You-are-blocked-by-Cloudflare',
  SHARE_INVITE_REGION: 'https://www.sync.com/help/shareinviteregion',
  SHARE_VERIFICATION_FAILED: 'https://help.sync.com/hc/en-us/articles/43649952207251-Share-Error-1609',
  FREE_CLOUD_STORAGE_TRIAL: 'https://www.sync.com/free-cloud-storage-from-trial/?_m=errshare',
  PRICING: 'https://www.sync.com/pricing',
  TERMS: 'https://www.sync.com/terms/',
  PRIVACY: 'https://www.sync.com/privacy/',
  STRONG_PASSWORD_TIPS:
    'https://help.sync.com/hc/en-us/articles/38275625420051-What-can-I-do-to-ensure-my-files-are-encrypted-and-my-Sync-account-is-secure#securitystrongpass',
  STRONG_PASSWORD_HELP: 'https://www.sync.com/help/strongreset',
  PASSWORD_RESET_HELP: 'https://www.sync.com/help/pwresethelp',
  MIGRATE_LEGACY_TEAM_HELP: 'https://www.sync.com/help/legacyteamsmigration',
  DEVICE_INSTALL_HELP: 'https://www.sync.com/install',
  ACCOUNT_TRANSFER_HELP: 'https://www.sync.com/help/getting-started-with-pro-teams-plus/#bprotransferuser',
  GDPR_POLICY: 'https://www.sync.com/privacy-policy-gdpr/',
  PRIVACY_CENTER: 'https://www.sync.com/help/privacycenter',
  ACCOUNT_UPGRADE: 'https://www.sync.com/accountupgrade',
  ZIP_DOWNLOADS: 'https://www.sync.com/help/zipdownload',
  LOGIN_ERROR_9429: 'https://help.sync.com/hc/en-us/articles/38275572525971-Login-Error-9429',
  EMAIL_BASED_PASSWORD_RESET:
    'https://help.sync.com/hc/en-us/articles/48451511025811-How-do-I-enable-or-disable-email-based-password-reset',
  ADD_USER_HELP: 'https://www.sync.com/help/adduserhelp/',
  SUPPORT: 'https://www.sync.com/support/',
  WHY_FILES_NOT_SYNCING: 'https://www.sync.com/help/why-arent-certain-files-on-my-computer-syncing/',
};

export const EMPTY_STATE_MESSAGES = {
  FILES: {
    title: 'No files here yet. Let’s get started.',
    subtitle: 'Upload files to store, organize, and access them securely from anywhere.',
  },

  VAULT: {
    title: 'Your Vault is empty.',
    subtitle:
      'Vault is a cloud-only storage space. Files added to Vault do not get synced to your other devices, allowing you to free up space and backup your local files to the cloud.',
  },

  TRASH: {
    title: 'This folder has no deleted items.',
    subtitle: '',
  },

  RECENTS: {
    title: 'No recent files.',
    subtitle: 'Files you’ve recently accessed or edited will appear here.',
  },

  LINKS: {
    title: 'No shared links.',
    subtitle: 'Create a share link to give others access to your files or folders.',
  },

  SHARES: {
    internal: {
      title: 'No shared folders.',
      subtitle: 'Share a folder to start collaborating with others.',
    },
    external: {
      title: 'No external shares found.',
      subtitle: 'Start collaborating with people outside your team by sharing a folder.',
    },
  },

  STARRED: {
    title: 'No starred files.',
    subtitle: {
      prefix: 'Mark a file or folder with a star in your ',
      suffix: ' to quickly access it from this page.',
    },
  },
} as const;

export const PRICING_LINKS = {
  BASE: 'https://www.sync.com/pricing',
  APP: 'https://www.sync.com/pricing-fromapp',
};

export const HUBSPOT_LINKS = {
  THANK_YOU_PAGE: '/thank-you-for-choosing-sync',
  THANK_YOU_PAGE_APP: '/thank-you-for-choosing-sync-fromapp',
};

export const BASE_ROUTE_REGEX = /^(\/[^\/\?]*)/;
// Matches an HTML anchor element and captures its inner content.
export const HTML_ANCHOR_REGEX = /<a\b[^>]*>([\s\S]*?)<\/a>/gi;

export const API_REQUESTS_BATCH_SIZE = 8;
export const BATCH_ACTION_RETRY_COUNT = 2;
export const BATCH_ACTION_RETRY_TIMEOUT_MS = 10000;

export const MAX_FILENAME_LENGTH = 250;
export const MAX_FILENAME_EXTENSION_LENGTH = 8;
